import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';

import { KnBrMyQuoteItemsComponent } from './kn-br-my-quote-items.component';
import { KnBrMyQuoteItemModule } from './kn-br-quote-item/kn-br-my-quote-item.module';

@NgModule({
  declarations: [KnBrMyQuoteItemsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    NgSelectModule,
    KnBrMyQuoteItemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrStep2CustomerQuoteItemsComponent: {
          component: () => import('./kn-br-my-quote-items.component').then((c) => c.KnBrMyQuoteItemsComponent),
        },
      },
    } as CmsConfig),
    SpinnerModule,
  ],
  exports: [KnBrMyQuoteItemsComponent],
})
export class KnBrMyQuoteItemsModule {}
